module.exports = __webpack_public_path__ + "static/access02-5d4b06af0e8ca0ce80138a6154024d64.png";